export default "__VITE_ASSET__7xefIrfH__"